import { useParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: July 2026",
    paragraphs: [
      "Everyday Essentials collects only the information needed to fulfil your order — your name, contact details, and delivery address. We never sell, rent, or share your personal data with third parties for marketing purposes.",
      "Payment information is processed by PCI-DSS compliant payment partners over 256-bit encrypted connections. We never store your full card details on our servers.",
      "You may request a copy or deletion of your personal data at any time by writing to support@everydayessentials.in. We respond to all data requests within 7 business days.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    updated: "Last updated: July 2026",
    paragraphs: [
      "By placing an order with Everyday Essentials, you agree to provide accurate delivery and contact information. Orders are confirmed once payment is authorised or, for Cash on Delivery, once the order is verified by our team.",
      "All product prices are listed in Indian Rupees (₹) and include applicable taxes. We reserve the right to correct pricing errors and will always notify you before dispatch if a correction affects your order.",
      "Product images are representative. Because many of our products use natural materials, minor variations in tone and texture are normal and are not considered defects.",
    ],
  },
  shipping: {
    title: "Shipping Policy",
    updated: "Last updated: July 2026",
    paragraphs: [
      "Orders are processed within 24 hours, Monday to Saturday. Metro cities typically receive deliveries in 2–4 business days; all other serviceable locations in 4–6 business days.",
      "Shipping is free on all orders above ₹999. Orders below ₹999 are charged a flat ₹79. We currently ship across India via Delhivery, BlueDart, and Ecom Express.",
      "Once dispatched, you will receive a live tracking link by SMS and email. If your order hasn't arrived within 8 business days, contact support@everydayessentials.in and we will make it right.",
    ],
  },
  refund: {
    title: "Refund Policy",
    updated: "Last updated: July 2026",
    paragraphs: [
      "We offer a hassle-free 7-day return and exchange window from the date of delivery. Items must be unused, in original packaging, and accompanied by the order number.",
      "For damaged or defective items, we offer a free replacement or a full refund — your choice — with no return shipping cost. Refunds are processed to the original payment method within 5–7 business days of pickup.",
      "Cash on Delivery orders are refunded via UPI or bank transfer. To start a return, email support@everydayessentials.in with your order number and a photo of the item.",
    ],
  },
};

export default function PolicyPage() {
  const { slug } = useParams();
  const policy = CONTENT[slug] || CONTENT.privacy;

  return (
    <main data-testid="policy-page" className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <Reveal>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-neutral-400">{policy.updated}</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl" data-testid="policy-title">
          {policy.title}
        </h1>
        <div className="mt-8 space-y-5">
          {policy.paragraphs.map((p, i) => (
            <p key={i} className="text-sm leading-relaxed text-neutral-600 sm:text-base">
              {p}
            </p>
          ))}
        </div>
      </Reveal>
    </main>
  );
}
